import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-data-introduce',
  templateUrl: './data-introduce.component.html',
  styleUrls: ['./data-introduce.component.css']
})
export class DataIntroduceComponent implements OnInit {
  type = '卫星遥感数据分发';
  news: any = [];


  constructor(private router: Router, private service: LoginService,) { }

  getInfo() {
    this.service.getNews(this.type).subscribe((res: any) => {
      console.log(res)
      this.news = res['result']
    })
  }

  detail(e) {
    console.log('我看下这个能不能获取到id', e)
    localStorage.setItem('detailtit', e.title)
    localStorage.setItem('detailtime', e.time)
    localStorage.setItem('detailcontent', e.content)
    localStorage.setItem('detailImg', e.fileid)
    this.router.navigate(['/detail'])
  }

  ngOnInit() {
    this.getInfo();
  }



  // intro(num) {
  // if (num == 2) {
  //     this.router.navigate(["home/centerHome/nature"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   } else if (num == 3) {
  //     this.router.navigate(["home/centerHome/production"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  //    else if (num == 4) {
  //     console.log("wozhixingle");
  //     this.router.navigate(["home/centerHome/ecotope"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  //   else if (num == 5) {
  //     console.log("wozhixingle");
  //     this.router.navigate(["home/centerHome/agriculture"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  //   else if (num == 6) {
  //     console.log("wozhixingle");
  //     this.router.navigate(["home/centerHome/antiTerrorist"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  //   else if (num == 7) {
  //     console.log("wozhixingle");
  //     this.router.navigate(["home/centerHome/calamities"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  //   else if (num == 8) {
  //     console.log("wozhixingle");
  //     this.router.navigate(["home/centerHome/culturalRelic"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  //   else if (num == 9) {
  //     console.log("wozhixingle");
  //     this.router.navigate(["home/centerHome/beautifulCountry"], {
  //       queryParams: {
  //         compareData: "tab" + 3
  //       }
  //     });
  //   }
  // }
}
